<template lang="html">
  <v-list two-line avatar>
    <v-list-item v-for="(user, index) in project_members" :key="index"
    @click="setProjectMembersSelectedIndex(index)"
    :style="getProjectMembersSelectedIndex === index? 'background-color: #616161':''">
      <v-list-item-avatar color="grey">
        <v-img v-if="user.image !== 'noimage'" :src="user.image" />
        <span v-else class="white--text pl-2">{{user.first_name[0].toUpperCase() + user.last_name[0].toUpperCase()}}</span>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ user.first_name + ' ' + user.last_name}} {{user.email === current_user.email ? '(You)':''}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  props: ['project_members', 'current_user'],
  computed: {
    ...mapGetters('View', [
      'getProjectMembersSelectedIndex'
    ])
  },
  methods: {
    ...mapActions('View', [
      'setProjectMembersSelectedIndex'
    ])
  }
}
</script>

<style lang="css" scoped>
</style>
